import StockView from 'src/sections/stock/stock/view/stock-view';

export default function StockPage() {
  return <StockView />;
}
